import * as yup from "yup";

const editEmployeeSchema = (dropdowns) =>
  yup.object().shape({
    employmentStatus: yup
      .string()
      .nullable()
      .test({
        name: "validate-employmentStatus",
        test: (value, ctx) => {
          if (!dropdowns?.employmentStatusesField.includes(value)) {
            return ctx.createError({
              message: "Insert a valid Employment Status",
            });
          }
          return true;
        },
      }),
  });

export default editEmployeeSchema;
